var React = require('react');

function ArrowDoubleTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.5 3.22412L4.36194 7.36217L5.30475 8.30497L8.5 5.10973L11.6953 8.30497L12.6381 7.36217L8.5 3.22412ZM8.5 6.99071L4.36194 11.1288L5.30475 12.0716L8.5 8.87631L11.6953 12.0716L12.6381 11.1288L8.5 6.99071Z","fill":"white"}));
}

ArrowDoubleTop.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = ArrowDoubleTop;

ArrowDoubleTop.default = ArrowDoubleTop;
